import type { AfterNavigate, BeforeNavigate } from '@sveltejs/kit';
import type { GuardNode } from './guardNode';
import { GUARDS } from '../index';

/**
 * Finds all matching guard nodes for a given path, ordered from deepest to shallowest
 */
const findMatchingGuardNodes = (
  pathname: string,
  guardsTree: GuardNode,
  currentPath = '',
): Array<{ path: string; guards: GuardNode['guards'] }> => {
  const results: Array<{ path: string; guards: GuardNode['guards'] }> = [];

  if (pathname.startsWith(currentPath)) {
    if (guardsTree.guards.length > 0) {
      results.push({ path: currentPath, guards: guardsTree.guards });
    }

    if (guardsTree.children) {
      for (const [segment, childNode] of Object.entries(guardsTree.children)) {
        const childPath = currentPath === '' ? `/${segment}` : `${currentPath}/${segment}`;
        if (pathname.startsWith(childPath)) {
          results.push(...findMatchingGuardNodes(pathname, childNode, childPath));
        }
      }
    }
  }

  return results;
};

export const runGuards = async (event: AfterNavigate | BeforeNavigate) => {
  const targetPathname = event.to?.url.pathname;

  if (!targetPathname) {
    return;
  }

  const matchingNodes = findMatchingGuardNodes(targetPathname, GUARDS);

  const orderedNodes = matchingNodes.reverse();

  for (const node of orderedNodes) {
    if (node.guards.length > 0) {
      const guardInstances = node.guards.map((Guard) => new Guard(event));
      await Promise.all(guardInstances.map((instance) => instance.run()));
    }
  }
};
